import React from 'react'
import AdminMomentAttendance from '../../features/admin/AdminMomentAttendance'

const AdminMomentAttendancePage = () => {
  return <AdminMomentAttendance/>
}

export default AdminMomentAttendancePage